/**
 * ActivationStatementsCtrl controller
 * Show past statements on activation page
 */

import {
  CATEGORY_TYPES,
  EXTERNAL_PAYMENT_SYSTEM_TYPES,
  MONETIZATION_TYPES,
  PAYMENT_STATUSES,
  PAYMENT_SYSTEM_TYPES,
  PAYMENT_TYPES,
  PRODUCT_TYPES,
  PURCHASE_STATUSES
} from 'app/core/constants'

/**
 * ActivationStatementsCtrl controller
 *
 * @class ActivationStatementsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationStatementsCtrl
 */
/* @ngInject */
export default function ActivationStatementsCtrl ($uibModal, $location, $sce, Purchase, PaymentStatement, Subscriber, storageSvc, subscr) {
  var vm = this

  /**
   * Subscriber
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   * @type {models.Subscriber}
   */
  vm.subscr = subscr

  /**
   * Payment system types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.payment_system_types
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Payment types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.payment_types
   * @type {Object}
   */
  vm.payment_types = PAYMENT_TYPES

  /**
   * External Payment System types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.external_payment_system_types
   * @type {Object}
   */
  vm.external_payment_system_types = EXTERNAL_PAYMENT_SYSTEM_TYPES

  /**
   * Category Types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.category_types
   * @type {Object}
   */
  vm.category_types = CATEGORY_TYPES

  /**
   * Payment statuses
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.payment_statuses
   * @type {Object}
   */
  vm.payment_statuses = PAYMENT_STATUSES

  /**
   * Payment statuses
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.payment_statuses
   * @type {Object}
   */
  vm.purchase_statuses = angular.copy(PURCHASE_STATUSES)
  delete vm.purchase_statuses.VOIDED

  /**
   * Product Types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.product_types
   * @type {Object}
   */
  vm.product_types = PRODUCT_TYPES

  /**
   * Monetization Types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.monetization_types
   * @type {Object}
   */
  vm.monetization_types = MONETIZATION_TYPES

  /**
   * Currencies
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @type {models.Currency}
   */
  if (storageSvc.local.get('currencies')) {
    vm.currencies = JSON.parse(storageSvc.local.get('currencies'))
  } else {
    vm.currencies = []
  }

  /**
   * Purchases
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getPurchases = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'createdTime'
      tableState.sort.reverse = true
    }

    Purchase.getPurchases(tableState, vm.subscr.id)
      .then(
        data => {
          vm.statements = data.content
        }
      )
  }

  /**
   * Edit comment for payment statement
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @function
   * @param  {models.PaymentStatement} statement
   */
  vm.editComment = null

  /**
   * Return object keys length
   *
   * @memberof mwApp/subscriber.controller:ActivationStatementsCtrl
   * @function
   * @param obj
   * @return number
   */
  vm.objectKeysLength = function (obj) {
    return Object.keys(obj).length
  }

  /**
   * Return currency by code
   *
   * @memberof mwApp/subscriber.controller:ActivationStatementsCtrl
   * @function
   * @return  {model.Currency}
   * @param code
   */
  vm.getCurrencyByCode = function (code) {
    return vm.currencies.find(c => c.name === code)
  }

  vm.showDashFrom = function (item) {
    return ['Custom_Charge', 'Add_On', 'Misc', 'Accessory'].includes(item.productType)
  }

  vm.showDashUntil = function (item) {
    if (['Custom_Charge', 'Add_On', 'Misc', 'Accessory'].includes(item.productType)) {
      return true
    }
    return ['Add_On', 'Content_Item'].includes(item.productType) && ['PURCHASE', 'BUY'].includes(item.monetizationType)
  }
  vm.showDashLength = function (item) {
    if (['Add_On', 'Content_Item'].includes(item.productType) && ['PURCHASE', 'BUY'].includes(item.monetizationType)) {
      return true
    }
    return ['Custom_Charge', 'Add_On', 'Misc', 'Accessory'].includes(item.productType)
  }

  vm.loadDiscountIcon = function () {
    return $sce.trustAsHtml(`<svg width="11" height="14" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.082 3.30469C13.5039 3.72656 13.75 4.28906 13.75 4.88672V15.75C13.75 17.0156 12.7305 18 11.5 18H2.5C1.23438 18 0.25 17.0156 0.25 15.75V2.25C0.25 1.01953 1.23438 0 2.5 0H8.86328C9.46094 0 10.0234 0.246094 10.4453 0.667969L13.082 3.30469ZM12.0625 15.75V5.625H9.25C8.61719 5.625 8.125 5.13281 8.125 4.5V1.72266H2.5C2.18359 1.72266 1.9375 1.96875 1.9375 2.28516V15.75C1.9375 16.0664 2.18359 16.3125 2.5 16.3125H11.5C11.7812 16.3125 12.0625 16.0664 12.0625 15.75ZM8.65234 8.40234C8.96875 8.08594 9.49609 8.08594 9.8125 8.4375C10.1641 8.75391 10.1641 9.28125 9.8125 9.59766L8.16016 11.25L7 12.4453L5.34766 14.0977C4.99609 14.4492 4.46875 14.4492 4.15234 14.0977C3.80078 13.7812 3.80078 13.2539 4.15234 12.9375L5.80469 11.25L7 10.0898L8.65234 8.40234Z" fill="#333333"/>
                                      <path d="M5.56176 8.99999C5.56176 9.46944 5.1812 9.84999 4.71176 9.84999C4.24231 9.84999 3.86176 9.46944 3.86176 8.99999C3.86176 8.53055 4.24231 8.14999 4.71176 8.14999C5.1812 8.14999 5.56176 8.53055 5.56176 8.99999Z" fill="#333333"/>
                                      <path d="M10.0635 13.5018C10.0635 13.9713 9.68297 14.3518 9.21353 14.3518C8.74408 14.3518 8.36353 13.9713 8.36353 13.5018C8.36353 13.0324 8.74408 12.6518 9.21353 12.6518C9.68297 12.6518 10.0635 13.0324 10.0635 13.5018Z" fill="#333333"/>
                                    </svg>`)
  }

  vm.openDiscountModal = function (statement) {
    $uibModal.open({
      templateUrl: 'components/subscribers/activation/modals/discountDetailsModal.html',
      controller: 'DiscountDetailsModalCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        item: function () {
          return statement
        },
        purchaseNumber: function () {
          return statement.purchaseNumber
        }
      }
    })
  }

  vm.goToPayment = function (purchaseNumber) {
    $location.hash('payment-history')
    $location.search('paymentNumber', purchaseNumber)
  }
}
